import React, { useState } from "react";
import "./userRegister.css";
import UserLogin from "./userLogin";

// Split-screen registration layout using existing column classnames

const UserRegister = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showLogin, setShowLogin] = useState(false);

    // form state
    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [whatsapp, setWhatsapp] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    if (showLogin) {
        return <UserLogin />;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            alert("Las contraseñas no coinciden.");
            return;
        }

        try {
            setSubmitting(true);

            const response = await fetch(
                "https://nodeapi.juan1ondonolinks.com/api/users/register",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        nombre: fullName,
                        email: email,
                        password: password,
                    }),
                }
            );

            if (!response.ok) {
                const errorText = await response.text();
                console.error("Error response:", errorText);
                alert("Error al registrar usuario.");
                return;
            }

            alert("Registro exitoso.");
            setShowLogin(true);
        } catch (err) {
            console.error(err);
            alert("No se pudo conectar con el servidor.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="two-column-container">
            {/* Branding zone */}
            <div className="left-column">
                <div className="left-column-inner">
                    <div className="logo-play">
                        <div className="logo-play-triangle" />
                    </div>
                    <div className="logo-text">CLIPEROS</div>
                </div>
            </div>

            {/* Interaction zone */}
            <div className="right-column">
                <div className="form-shell">
                    {/* Header logo + title */}
                    <div className="form-header-logo">
                        <div className="logo-play" style={{ boxShadow: "0 8px 16px rgba(255, 94, 125, 0.35)" }}>
                            <div className="logo-play-triangle" />
                        </div>
                        <div className="logo-text" style={{ fontSize: 22 }}>CLIPEROS</div>
                    </div>

                    <h1 className="form-title">
                        Regístrate y gana dinero publicando vídeos en las redes sociales.
                    </h1>
                    <p className="form-subtitle">
                        Crea tu cuenta en menos de un minuto y empieza a monetizar tu
                        contenido.
                    </p>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="fullName" className="form-label">
                                Nombre completo
                            </label>
                            <input
                                id="fullName"
                                type="text"
                                className="form-input"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email" className="form-label">
                                Introduce tu correo electrónico
                            </label>
                            <input
                                id="email"
                                type="email"
                                className="form-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>


                        <div className="form-group password-wrapper">
                            <label htmlFor="password" className="form-label">
                                Crea tu contraseña
                            </label>
                            <input
                                id="password"
                                type={showPassword ? "text" : "password"}
                                className="form-input form-input-composite"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowPassword((v) => !v)}
                            >
                                {showPassword ? "🙈" : "👁"}
                            </button>
                        </div>

                        <div className="form-group password-wrapper">
                            <label htmlFor="confirmPassword" className="form-label">
                                Confirma tu contraseña
                            </label>
                            <input
                                id="confirmPassword"
                                type={showConfirmPassword ? "text" : "password"}
                                className="form-input form-input-composite"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowConfirmPassword((v) => !v)}
                            >
                                {showConfirmPassword ? "🙈" : "👁"}
                            </button>
                        </div>

                        <button type="submit" className="cta-button" disabled={submitting}>
                            {submitting ? "Enviando..." : "Registro"}
                        </button>
                    </form>

                    <div className="form-footer">
                        ¿Ya tienes una cuenta?{" "}
                        <button
                            type="button"
                            className="link-button"
                            onClick={() => setShowLogin(true)}
                        >
                            Inicia sesión aquí
                        </button>
                    </div>

                    <div className="copyright">
                        <span>Juan 1ondono · Todos los derechos reservados.</span>
                        <div className="ghost-icon">👻</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserRegister;
